import type { ReactNode } from "react";
import Layout from "../layout";

export type SiteLayoutProps = Parameters<typeof Layout>["0"] & {
  instanceId?: string;
};

export default function ({ children, instanceId, ...props }: SiteLayoutProps): ReactNode {
  return <Layout {...props}>{children}</Layout>;
}
